<template>
    <div class="base-layout">
        <AppHeader :key="'app-header'"/>
        <div>
            <div class="default-layout">
                <div class="container mx-auto py-4">
                    <div class="grid grid-cols-12 gap-4 max-[768px]:m-2">
                        <div class="contact md:col-start-1 lg:col-end-5 col-span-12"
                             :class="[
              {
                'contact_without_border':
                  currentView === 'chat',
                },
              ]">
                            <div class="lg:hidden" v-if="currentView === 'chat'">
                                <button class="btn btn-black mb-4" type="button"
                                        @click="currentView === 'list' ? currentView = 'chat' : currentView = 'list'">
                                    <ArrowIcon class="m-4" :class="{'flip-x': currentView === 'chat'}"/>
                                </button>
                            </div>
                            <div :class="{'hide-chat-section': currentView !== 'list'}">
                                <Suspense>
                                    <ChatList/>
                                </Suspense>
                            </div>
                        </div>
                        <NuxtPage class="lg:col-span-8 col-span-12"
                                  :class="{'hide-chat-section': currentView !== 'chat'}"/>
                        <TagList v-if="false" class="lg:col-span-3 col-span-12"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import TagList from "../components/Chat/TagList.vue";
import ArrowIcon from "../assets/img/icons/arrow.svg";
import {storeToRefs} from "pinia";
import {UserRole} from '~/types/userRole'

const {t: $t} = useI18n()

definePageMeta({
    role: [UserRole.MANAGER],
})


const route = useRoute()
const localePath = useLocalePath()
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const chatId = route.params.id

const {userInfo} = storeToRefs(useUserStore())

const {currentView} = storeToRefs(useChatStore())

if (chatId !== undefined) {
    currentView.value = 'chat';
}
</script>
<style lang="scss">
.show-profile-section {
  font-weight: 700;
}
.contact:not(.header__menu-txt) {
  border-radius: 20px;
  padding: 20px;
  outline:2px solid #aeaeae30;
}
.contact__header {
  font-size: 20px;
  font-weight: 700;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.contact__list {
  overflow-y: scroll;
  height: 71vh;
}
.form__container {
  display: flex;
  margin: 15px 0;
}
.form__container--search {
  width: 100%;
  border-radius: 20px;
  border: 1px solid #353535;
  background: rgb(255 255 255 / 50%);
  color: #353535;
  font-family: Red Rose;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  padding: 15px 40px 15px 20px;
  margin-right: -70px;
}
.form__container--button {
  border-radius: 20px;
  border: 1px solid #353535;
  background: #353535;
  padding: 0 20px;
}
.box__user {
  display: grid;
  grid-template-columns: 0.25fr 1fr 0.1fr;
  grid-template-rows: 0.5fr 0.5fr;
  gap: 0px 15px;
  grid-template-areas:
    'img name icon'
    'img company icon';
  align-items: center;
  margin: 20px 0;
  cursor: pointer;
  padding: 15px;
  /*&:active {
    border: 1px solid;
    border-radius: 20px;
    background: rgb(255 255 255 / 50%);
  }*/
  &--img {
    grid-area: img;
  }
  &--name {
    grid-area: name;
    font-size: 20px;
    font-weight: 700;
  }
  &--company {
    grid-area: company;
    font-size: 16px;
    color: rgba(53, 53, 53, 0.5);
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &--icon {
    grid-area: icon;
  }
}
ul {
  padding-left: 0;
}
.right__content {
  padding: 15px;
  background: #f6f6f6;
  border-radius: 20px;
  display: grid;
  /*grid-template-rows: 0.2fr 3fr 0.2fr;*/
  gap: 1rem;
  &--header {
    display: grid;
    grid-template-columns: 0.1fr 1fr 0.06fr;
    grid-template-rows: 0.5fr;
    gap: 0px 20px;
    border-radius: 20px;
    background: #fff;
    color: #353535;
    font-weight: 700;
    font-size: 20px;
    align-items: center;
    align-content: center;
    justify-items: start;
    padding: 20px;
  }
  &--chat {
  }
}
.hide-chat-section {
  @media (max-width: 1024px) {
    display: none;
  }
}

.contact_without_border {
  @media (max-width: 1024px) {
    padding: 0px 10px;
    border-radius:0px;
    outline: 0;
  }
}

.flip-x {
  transform: scaleX(-1);
}
.profile__line {
  display: flex;
  align-items: center;
  gap: 15px;
  padding-top: 20px;
}
.contact__seller {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 650px;
  margin-top: 50px;
  &--img {
    margin: 35px 0;
    display: flex;
  }
  &--info {
    margin-bottom: 75px;
    text-align: center;
    color: #353535;
    font-family: Red Rose;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 29.724px;
  }
  &--footer {
    width: 460px;
  }
}
.seller--company {
  font-weight: 400;
  color: rgba(53, 53, 53, 0.5);
  font-size: 16px;
}
.seller--number {
  border-radius: 20px;
  background: #f6f6f6;
  text-align: center;
  padding: 10px;
  font-size: 16px;
  margin-bottom: 15px;
}
.btn--chat {
  width: 100%;
  background: #3870ff;
  gap: 10px;
  color: #fff;
}
.form__chat {
  &--send {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 20px;
  }
  &--text {
    border-radius: 20px;
    background: #fff;
    color: #c0c0c0;
    font-family: Red Rose;
    font-size: 16px;
    width: 100%;
    max-height: 80px;
    border: 1px solid #b6b6b6;
  }
  &--button {
    aspect-ratio: 1;
    border-radius: 20px;
    padding: 0 20px;
    border: 1px solid #3870ff;
    background: #3870ff;
    color: #fff;
    gap: 10px;
  }
}
.seller--content {
  color: #fff;
  font-family: Red Rose;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 29.724px;
  display: flex;
  justify-content: flex-end;
  margin: 15px 5px 0px 75px;
  & > p {
    border-radius: 20px;
    background: #3870ff;
    padding: 13px;
    box-shadow: 4px 6px 6px -2px rgba(66, 68, 90, 0.3);
    * {
      all: revert;
    }
  }
}
.client--content {
  color: #353535;
  font-family: Red Rose;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 29.724px;
  display: flex;
  gap: 15px;
  justify-content: flex-start;
  margin: 15px 75px 0px 0px;
  align-items: center;

  & > p {
    overflow-wrap: anywhere;
    max-width: 100%;
    border-radius: 20px;
    background: #fff;
    padding: 13px;
    box-shadow: 4px 6px 6px -2px rgba(66, 68, 90, 0.3);

    * {
      all: revert;
    }
  }
}
@media (max-width: 1496px) {
  .right__content {
    &--header {
      p {
        font-size: var(--font-xsmall);
      }
    }
  }
  .profile {
    &__line {
      p {
        font-size: var(--font-xsmall);
      }
    }
    &__info {
      font-size: var(--font-exsmall);
    }
  }
  .contact__header {
    p {
      font-size: var(--font-small);
    }
  }
  .form__container {
    margin: 0;
    &--search {
      padding: 10px;
    }
  }
  .form__chat {
    &--text {
      max-height: 60px;
    }
    &--button {
      svg {
        width: 16px;
      }
    }
  }
  .contact__list {
    margin-top: 10px;
  }
  .box__user {
    padding: 5px;
    margin: 10px 0;
    &--img {
    }
    &--name {
      font-size: var(--font-xsmall);
    }
    &--company {
      font-size: var(--font-exsmall);
    }
    &--updated-at {
      font-size: var(--font-exsmall) !important;
    }
  }
  .seller--content,
  .client--content {
    font-size: var(--font-exsmall);
    gap: 10px;
    padding: 10px;
    p {
      padding: 5px 10px;
    }
    ::after {
      font-size: var(--font-exsmall);
      margin: 0;
    }
  }
}
@media (max-width: 768px) {
  .form {
    &__chat {
      &--send {
        gap: 10px;
      }
    }
  }
  [class*='__container'] {
    max-width: 100%;
  }
  .contact__list {
    margin-top: 0;
  }
  .form__chat--text {
    box-shadow: 4px 6px 6px -2px rgba(66, 68, 90, 0.3);
  }
}
@media (max-width: 500px) {
  .right__content--header {
    grid-template-columns: 0.25fr 1fr 0.25fr;
    padding: 10px;
    border: 1px solid;
    justify-items: center;
    height: 75px;
  }
  .client--content {
    margin: 15px 65px 0px 0px;
    padding: 0px 0px 5px 0px;
  }
  .seller--content {
    margin: 15px 5px 0px 65px;
    padding: 0px 0px 5px 0px;
  }
}
</style>

